//@flow
import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Typography, makeStyles, Grid} from '@material-ui/core';

import CustomModal from '../../../../elements/CustomModal/CustomModal';
import TiendadaRadioButton from '../../../../elements/tiendada-radio-button';
import {useToggle} from '../../../../utils/react';

import {HelpTwoTone, Add} from '@material-ui/icons';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {TIENDADA_LINKS} from '../../../../constants';
import {colors} from '../../../../assets/styles/colors';
import CrmSegmentTable from './crm-segment-table';
import {useIsFeatureInTier} from '../../../../utils/component';
import UpgradeIcon from '../../../../elements/icons/UpgradeIcon';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
  },

  headerWrapper: {
    padding: '1rem',
  },
  ayudaButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    margin: '0 14px 0 0',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      fontSize: '12px',
      margin: '0 16px 0 0',
      padding: 0,
      boxShadow: 'unset',
    },
  },
  tutorialsButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      padding: 0,
      boxShadow: 'unset',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
  modalContainer: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    maxWidth: '550px',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },

  upgradeButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '.5rem auto',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    '&:hover': {
      backgroundColor: colors.grey200,
    },
  },
  upgradeButtonLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',

    '&[data-disabled="true"]': {
      pointerEvents: 'none',
      opacity: 0.5,
    },
  },
}));

export default function CrmSegmentSummary() {
  const classes = useStyles();
  const [modalOpen, toggleModalOpen] = useToggle(false);
  const [typeSelected, setTypeSelected] = useState('MANUAL');
  const history = useHistory();

  const tiendachatFeature = useIsFeatureInTier('CRM_SEGMENT');

  const handleCreateSegment = () => {
    if (typeSelected === 'MANUAL') {
      console.log({typeSelected});
      history.push('/segments/manual/new');
    } else {
      history.push('/segments/dynamic/new');
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerWrapper}>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <Typography className={classes.title}>Segmentos</Typography>
          </Grid>
          <Grid item>
            <CustomButton
              href={TIENDADA_LINKS.customerSupport.general}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.ayudaButton}
              startIcon={<HelpTwoTone />}
            >
              Ayuda
            </CustomButton>
            <CustomButton
              variant="contained"
              startIcon={<Add />}
              /*               component={Link}
              to="/segments/manual/new" */
              onClick={toggleModalOpen}
              disabled={!tiendachatFeature}
            >
              Crear Segmento
            </CustomButton>
          </Grid>
        </Grid>
      </div>

      {!tiendachatFeature && (
        <CustomButton className={classes.upgradeButton} to="/tiers-list">
          <div className={classes.whiteButtonLabel}>
            <span>Mejora tu plan para acceder a esta funcionalidad</span>
            <UpgradeIcon width={18} height={18} />
          </div>
        </CustomButton>
      )}

      <div className={classes.container} data-disabled={!tiendachatFeature}>
        <CrmSegmentTable />
      </div>

      <CustomModal open={modalOpen} onClose={toggleModalOpen}>
        <aside className={classes.modalContainer}>
          <Typography className={classes.modalTitle}>
            Seleccionar el tipo de segmento
          </Typography>
          <div className={classes.modalContent}>
            <TiendadaRadioButton
              name="include-contacts"
              label="Segmento Manual"
              onChange={() => setTypeSelected('MANUAL')}
              description="Carga un archivo de excel con los contactos que deseas incluir en el segmento"
            />
            <TiendadaRadioButton
              name="include-contacts"
              label="Segmento Dinámico"
              onChange={() => setTypeSelected('DYNAMIC')}
              description="Crea un segmento dinámico basado en los datos de tus clientes"
            />
          </div>
          <footer>
            <CustomButton
              className={classes.modalButton}
              variant="contained"
              color="primary"
              onClick={handleCreateSegment}
            >
              Crear Segmento
            </CustomButton>
          </footer>
        </aside>
      </CustomModal>
    </div>
  );
}
